import React, { useState } from 'react';
import Table from '../../layout/forms/Table'
import { useEffect } from 'react';
import apiProjectData from '../../../api/projectDatas';


const ProjectData = ({selectedGlobalObjectKey}) => {   
    const [projectData, setProjectData] = useState([]);
    useEffect(() => {
        if (selectedGlobalObjectKey === null) {
            setProjectData([]);
            return;
        }
        const reloadProjectData = async () => {
            const dataProjectData = await apiProjectData.get(
                selectedGlobalObjectKey
            );
            setProjectData(dataProjectData);
        }
        reloadProjectData();
    }, [selectedGlobalObjectKey]);
    return (
        <Table title="Project Data"
            rowsPerPage={100}
            columns={[
                { title: 'ProjectName', field: 'projectName', width: 200 },
                { title: 'MasterProjectKey', field: 'masterProjectKEY', width: 200 },
                { title: 'GlobalProjectKey', field: 'globalProjectKEY', width: 200 },
                { title: 'ProjectHb', field: 'projectHb', width: 200 },

            ]} data={projectData} />
        );
};
export default ProjectData;


